import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["otherWrap", "otherReason", "submit"]

  connect() {
    this.sync()
  }

  sync() {
    const selected = this.element.querySelector("input.source-select:checked")
    const value = selected?.value || ""
    const isOther = value === "Other"

    if (this.hasOtherWrapTarget) {
      this.otherWrapTarget.style.display = isOther ? "block" : "none"
    }

    if (this.hasOtherReasonTarget) {
      this.otherReasonTarget.required = isOther
      if (!isOther) this.otherReasonTarget.value = ""
    }

    const otherOk =
      !isOther ||
      (this.hasOtherReasonTarget &&
        this.otherReasonTarget.value.trim().length > 0)

    if (this.hasSubmitTarget) {
      this.submitTarget.disabled = !(value && otherOk)
    }
  }
}
